<template>
  <div>
    <section class="title-box">
      <div class="container">
        <h1>{{ $t("套票種類") }}</h1>
      </div>
    </section>
    <section class="main-box" v-if="MProductData">
      <div class="container">
        <div class="btn-box">
          <!-- 0517 換img圖 -->
          <div class="btn ticket-btn" id="btn">
            <router-link :to="{ name: 'MProductList' }" tag="button"><img src="img/icon-month2.png" alt="" />{{
              $t("月票")
            }}</router-link>
            <button class="btnadd">
              <img src="img/icon-season.png" alt="" />{{ $t("季票") }}
            </button>
            <router-link :to="{ name: 'ProductList' }" tag="button"><img src="img/icon-time.png" alt="" />{{
              $t("時數票")
            }}</router-link>
          </div>
          <div class="tag">
            <div class="btn area-btn" id="btn">
              <button :class="selectCity == 0 ? 'btnadd' : ''" @click="selectCity = 0">
                {{ $t("全部") }}
              </button>
              <button :class="selectCity == 1 ? 'btnadd' : ''" @click="selectCity = 1">
                {{ $t("高雄") }}
              </button>
              <button :class="selectCity == 3 ? 'btnadd' : ''" @click="selectCity = 3">
                {{ $t("臺南") }}
              </button>
              <button :class="selectCity == 2 ? 'btnadd' : ''" @click="selectCity = 2">
                {{ $t("屏東") }}
              </button>
              <button :class="selectCity == 4 ? 'btnadd' : ''" @click="selectCity = 4">
                {{ $t("南嘉嘉") }}
              </button>
            </div>
            <div class="btn card-btn" id="btn">
              <button :class="selectType == 0 ? 'btnadd' : ''" @click="selectType = 0">
                {{ $t("全部") }}
              </button>
              <button :class="selectType == 2 ? 'btnadd' : ''" @click="selectType = 2">
                {{ $t("卡片") }}
              </button>
              <button :class="selectType == 1 ? 'btnadd' : ''" @click="selectType = 1">
                {{ $t("QR") }}
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="box col-12 col-md-6 col-lg-3" v-for="MProduct in MProductData.MProducts_All"
            :key="MProduct.o_maas_pt_seq" :style="(selectCity == 0 ||
              (selectCity == 1 && (MProduct.o_maas_pt_city.includes('01') || MProduct.o_maas_pt_city.includes('1F'))) ||
              (selectCity == 2 && (MProduct.o_maas_pt_city.includes('02') || MProduct.o_maas_pt_city.includes('1F'))) ||
              (selectCity == 3 && (MProduct.o_maas_pt_city.includes('03') || MProduct.o_maas_pt_city.includes('1F'))) ||
              (selectCity == 4 && (MProduct.o_maas_pt_city.includes('21') || MProduct.o_maas_pt_city.includes('22') || MProduct.o_maas_pt_city.includes('23')))) &&
              (selectType == 0 ||
                (selectType == 2 && MProduct.o_maas_pt_code_type == 1) ||
                (selectType == 1 && MProduct.o_maas_pt_code_type == 2))
              ? ''
              : 'display: none;'
              ">
            <img :src="SiteUrl + MProduct.o_maas_pt_photo" alt="" />
            <!-- 0613 擴大a連結  -->
            <router-link :to="{
              name: 'SProductBuy',
              params: { o_maas_pt_seq: MProduct.o_maas_pt_seq },
            }">
              <div class="text-box">
                <h2>{{ MProduct.o_maas_pt_name_zh_tw }}</h2>
                <!-- <img src="img/icon-transportation.png" alt="" /> -->
                <div style="display: flex" v-html="MProduct.o_maas_pt_transport"></div>
                <div class="price">
                  <p v-if="MProduct.o_maas_pt_ori_price > 0">
                    NTD{{ MProduct.o_maas_pt_ori_price }}
                  </p>
                  <p v-if="MProduct.o_maas_pt_ori_price == 0"></p>
                  <p>NTD</p>
                  <p>{{ MProduct.o_maas_pt_price }}</p>
                </div>
                <!-- 0613 修改 a連結改成div -->
                <div class="shopping-cart">
                  <img src="img/icon-shopping-cart.png" alt="" />
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import CryptoJS from "crypto-js";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
  zh_tw: {
    "全部": "全部",
    "高雄": "高雄",
    "屏東": "屏東",
    "臺南": "臺南",
    "套票種類": "套票種類",
    "月票": "月票",
    "時數票": "時數票",
    "一般": "一般",
    "學生": "學生",
    "卡片": "卡片",
    "熱門套票": "熱門套票",
  },
  en: {
    "全部": "All",
    "高雄": "Kaohsiung",
    "屏東": "Pingtung",
    "臺南": "Tainan",
    "套票種類": "Pass type",
    "月票": "Monthly Pass",
    "時數票": "Hour pass",
    "一般": "General",
    "學生": "Student",
    "卡片": "Card",
    "熱門套票": "Popular",
  },
  jp: {
    "全部": "全部",
    "高雄": "高雄",
    "屏東": "屏東",
    "臺南": "臺南",
    "套票種類": "フリーパスの種類",
    "月票": "月票",
    "時數票": "フリーパス",
    "一般": "一般",
    "學生": "學生",
    "卡片": "卡片",
    "熱門套票": "人気のフリーパス",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "SProductList",
  i18n,
  data() {
    return {
      SiteUrl: "",
      MProductData: {},
      MProductsCount_All: 0,
      MProductsCount: 0,
      MProductsCount_Student: 0,
      MProductsCount_QR: 0,
      MProductsCount_QR_Student: 0,
      TopMProductData: {},
      TopMProductsCount: 0,
      CardType: 0,
      CodeType: 0,
      isFirstLoaded: false,
      MProductOnlyOne: false,
      selectCity: 0,
      selectType: 0,
    };
  },
  created: function () {
    Vue.axios
      .get(
        this.GLOBAL.apiSrc + this.GLOBAL.subDirectory + "/Htmlv2/MProductList",
        {
          params: {
            kind: 'S',
            token: Storage.get("ek_login_token"),
            lang: Storage.get("ek_site_lang")
          },
        }
      )
      .then((response) => {
        this.SiteUrl = response.data.SiteUrl;
        this.MProductData = response.data.MProductData;
        this.MProductsCount_All = response.data.MProductsCount_All;
        this.MProductsCount = response.data.MProductsCount;
        this.MProductsCount_Student = response.data.MProductsCount_Student;
        this.MProductsCount_QR = response.data.MProductsCount_QR;
        this.MProductsCount_QR_Student =
          response.data.MProductsCount_QR_Student;
        this.TopMProductData = response.data.TopMProductData;
        this.TopMProductsCount = response.data.TopMProductsCount;
        this.MProductOnlyOne = response.data.MProductOnlyOne;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("package-list");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
  },
  updated: function () {
    if ($(".package-check").hasClass("slick-initialized")) {
      $(".package-check").slick("unslick");
    }

    $(".package-nav-qr-general").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      asNavFor: ".package-for-qr-general",
    });

    $(".package-for-qr-general").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      // fade: true,
      asNavFor: ".package-nav-qr-general",
      dots: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            centerMode: false,
          },
        },
      ],
      autoplay: true,
      autoplaySpeed: 5000,
    });

    $(".package-nav-general").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      asNavFor: ".package-for-general",
    });

    $(".package-for-general").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      // fade: true,
      asNavFor: ".package-nav-general",
      dots: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            centerMode: false,
          },
        },
      ],
      autoplay: true,
      autoplaySpeed: 5000,
    });

    $(".package-nav-qr-student").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      asNavFor: ".package-for-qr-student",
    });

    $(".package-for-qr-student").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      // fade: true,
      asNavFor: ".package-nav-qr-student",
      dots: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            centerMode: false,
          },
        },
      ],
      autoplay: true,
      autoplaySpeed: 5000,
    });

    $(".package-nav-student").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      asNavFor: ".package-for-student",
    });

    $(".package-for-student").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      // fade: true,
      asNavFor: ".package-nav-student",
      dots: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            centerMode: false,
          },
        },
      ],
      autoplay: true,
      autoplaySpeed: 5000,
    });
  },
  methods: {
    changeCardType(cardType) {
      this.CardType = cardType;
      if (this.CardType == 0 && this.CodeType == 0) {
        $(".package-list .carousel-box-2").css("left", 0);
      } else if (this.CardType == 0 && this.CodeType == 1) {
        var width = $(".carousel-qr-general").width();
        $(".package-list .carousel-box-2").css("left", 0 - width);
      } else if (this.CardType == 1 && this.CodeType == 0) {
        var width = $(".carousel-qr-general").width();
        width += $(".carousel-general").width();
        $(".package-list .carousel-box-2").css("left", 0 - width);
      } else if (this.CardType == 1 && this.CodeType == 1) {
        var width = $(".carousel-qr-general").width();
        width += $(".carousel-general").width();
        width += $(".carousel-qr-student").width();
        $(".package-list .carousel-box-2").css("left", 0 - width);
      }
    },
    changeCodeType(codeType) {
      this.CodeType = codeType;
      if (this.CardType == 0 && this.CodeType == 0) {
        $(".package-list .carousel-box-2").css("left", 0);
      } else if (this.CardType == 0 && this.CodeType == 1) {
        var width = $(".carousel-qr-general").width();
        $(".package-list .carousel-box-2").css("left", 0 - width);
      } else if (this.CardType == 1 && this.CodeType == 0) {
        var width = $(".carousel-qr-general").width();
        width += $(".carousel-general").width();
        $(".package-list .carousel-box-2").css("left", 0 - width);
      } else if (this.CardType == 1 && this.CodeType == 1) {
        var width = $(".carousel-qr-general").width();
        width += $(".carousel-general").width();
        width += $(".carousel-qr-student").width();
        $(".package-list .carousel-box-2").css("left", 0 - width);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
section.main-box {
  min-height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/SProductList.vue